import { func, node, string } from "prop-types";
import { useFeatureContext } from "./featureContext";
import UpgradeOverlay from "./UpgradeOverlay";

const UpgradeGate = ({ children, renderGate, type, text }) => {
  const ctx = useFeatureContext();
  if (ctx.canAccess) return children;

  return ctx.canAccess ? (
    children
  ) : renderGate ? (
    renderGate(ctx, children)
  ) : (
    <UpgradeOverlay text={text} type={type}>
      {children}
    </UpgradeOverlay>
  );
};

UpgradeGate.propTypes = {
  children: node.isRequired,
  renderGate: func,
  type: string,
};

export default UpgradeGate;
